import React from 'react';

const UploadFile = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      width="20"
      height="20"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={`${
        props.className ? props.className : 'fill-blue hover:fill-white'
      }`}
    >
      <path fill="none" d="M0 0h24v24H0V0z" />
      <path d="M17 2H7C5.9 2 5 2.9 5 4v16c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V6l-5-4zm-1 14H8v-2h8v2zm0-3H8v-2h8v2zm0-3H8V8h8v2z" />
    </svg>
  );
};

export default UploadFile;
